// extracted by mini-css-extract-plugin
export default {"base":"vp_w8URj","title":"vp_GMmge","description":"vp_lwDCa"};